<template>
  <div class="mtr">
    <div class="t_header" v-if="w_width<888">
      <div class="fx_cs t_topbar">
        <img src="../assets/img/homepage/logotop.png" style="height: 28px" />
        <i class="iconfont iconzu1714" style="color: #FFFFFF" @click="change()"></i>
      </div>
      <div class="t_maindiv1" style="height: 340px">
        <img src="../assets/img/bg/3.jpg" style="height: 340px">
        <div class="t_mes">
          <img src="../assets/img/5.png" style="width: 122px">
          <div class="t_title">
            <div>TMIP产品体系</div>
            <div>MTR 物料溯源</div>
            <div />
          </div>
        </div>
      </div>
    </div>
    <div class="header" v-else>
      <div class="topbar">
        <img src="../assets/img/homepage/logotop.png" />
        <myheader></myheader>
      </div>
      <div class="widtol mesdiv1">
        <div class="mesdiv2">
          <span class="messp1">TMIP产品体系</span>
          <span class="messp2">MTR 物料溯源</span>
        </div>
        <div class="mesdiv3">
          <img src="../assets/img/5.png" style="width: 273px; height: 273px" />
        </div>
      </div>
    </div>
    <div class="t_maindiv1" style="height: 297px" v-if="w_width<888">
      <img src="../assets/img/bg/2.jpg" style="height: 297px;">
      <div class="t_txt9">
        <div>
          该系统能够进行全方位的质量追溯，降低质量失误成本，以减少无附加价值的生产活动，提升工厂生产效率，提升产品品质。结合TMIP-MES与WMS系统的集成部署，实现材料及生产过程全方位追溯。
        </div>
        <div style="margin-top: 20px">
          通过应用生产过程中的物料标签（条码、RFID），一物一码，从原料投入开始，包括中间工序在内，使用移动掌机记录工序投入、产出，追溯原材料、生产过程、工艺参数、加工人员、加工设备等信息（支持正向、反向追溯），提升物料质量管理水平
        </div>
      </div>
    </div>
    <div class="mesdiv4" v-else>
      <div class="widtol mesdiv5">
        <span class="messp3">MTR 物料溯源</span>
        <span class="messp4"
          >该系统能够进行全方位的质量追溯，降低质量失误的成本，以减少无附加价值的生产活动，提升工厂的生产效率，<br />
          提升产品品质。结合TMIP-MES与WMS系统的集成部署，就实现了整个产品的材料及生产过程全方位追溯。<br />
          通过应用生产过程中的物料标签（条码、RFID），一物一码，从原料投入开始，包括中间工序在内，使用移动掌机<br />
          记录工序投入、产出，支持正向、反向追溯，包括追溯原材料、生产过程、工艺参数、加工人员、加工设备等信<br />
          息，进而提升物料质量管理水平。</span
        >
      </div>
    </div>

    <div v-if="w_width<888">
      <div class="t_mes_info" style="background: #FFFFFF">
        <div class="t_mes_txt">应用场景</div>
        <img src="../assets/img/7.png" style="width: 80%;margin-left: 10%">
        <div class="t_mes_txt2">客户品质投诉追溯</div>
        <div class="t_mes_txt3">
          可根据出现问题的批次信息，一键查询出其原料组成、加工生产信息、经过设备信息、加工人员、品质质检、入出库详情等，直观清晰了解产品的整个生产情况，为快速定位出问题提供了数据支持
        </div>
      </div>
      <div class="t_mes_info">
        <img src="../assets/img/8.png" style="width: 100%;">
        <div class="t_mes_txt2">异常原料使用追溯</div>
        <div class="t_mes_txt3">
          根据发现的异常原料信息自下而上追溯，追溯到所有拥到此原料批次的产品信息，可及时正确对潜在的问题产品进行处理，减少损失
        </div>
      </div>
    </div>
    <div class="mesdiv6" v-else>
      <span class="messp5">应用场景</span>
      <div class="mesdiv7 widtol">
        <div class="mesdiv8 txt-left">
          <img src="../assets/img/7.png" style="width: 400px; height: 368px" />
        </div>
        <div class="mesdiv8">
          <div class="mesdiv9">
            <span class="messp6">客户品质投诉追溯</span>
            <span class="messp7"
              >可根据出现问题的批次信息，一键查询出其原料组成、加工生产信息、经过设备信息、<br />
              加工人员、品质质检、入出库详情等，直观清晰了解产<br />
              品的整个生产情况，为快速定位出问题提供了数据支持。</span
            >
          </div>
        </div>
      </div>
      <div class="mesdiv7 widtol">
        <div class="mesdiv8">
          <div class="mesdiv9" style="margin-left: 60px; padding-left: 0px">
            <span class="messp6">异常原料使用追溯</span>
            <span class="messp7"
              >根据发现的异常原料信息自下而上追溯，追溯到所有拥到此原<br />
              料批次的产品信息，可及时正确对潜在的问题产品进行处理，<br />
              减少损失。</span
            >
          </div>
        </div>
        <div class="mesdiv8 txt-right">
          <img src="../assets/img/8.png" style="width: 456px; height: 311px" />
        </div>
      </div>
    </div>

    <div style="background: #FFFFFF" v-if="w_width<888">
      <div class="t_mtr_txt1">基于RFID的物料追溯案例</div>
      <div class="t_mtr_case">
        <div class="t_mtr_txt2">羽绒生产过程</div>
        <div class="t_mtr_option">
          <div :class="[proShow?'t_mtr_chose':'t_mtr_unchose']" @click="proShow=true">
            原料入库
          </div>
          <div :class="[!proShow?'t_mtr_chose':'t_mtr_unchose']" @click="proShow=false">
            生产流程
          </div>
        </div>
        <img src="../assets/img/1651.jpg" style="width: 100%" v-if="proShow">
        <img src="../assets/img/1653.jpg" style="width: 100%" v-else>
      </div>
      <div style="height: 5px;background: #F9FAFB;width: 100%"></div>
      <div class="t_mtr_case">
        <div class="t_mtr_txt2">加工溯源过程示意图</div>
        <div class="t_mtr_option">
          <div :class="[macShow?'t_mtr_chose':'t_mtr_unchose']" @click="macShow=true">
            正向溯源
          </div>
          <div :class="[!macShow?'t_mtr_chose':'t_mtr_unchose']" @click="macShow=false">
            反向溯源
          </div>
        </div>
        <img src="../assets/img/1652.jpg" style="width: 100%" v-if="macShow">
        <img src="../assets/img/1654.jpg" style="width: 100%" v-else>
      </div>
    </div>
    <div v-else>
      <div class="mtrdiv1">
        <span class="mtrsp1">基于RFID的物料追溯案例</span>
        <span class="mtrsp2">羽绒生产过程</span>
      </div>
      <div class="widtol mtrdiv2">
        <img src="../assets/img/9.jpg">
      </div>
      <div class="widtol mtrdiv2">
        <img src="../assets/img/10.jpg">
      </div>
      <div class="mtrdiv1" style="padding-top:55px">
        <span class="mtrsp2">加工溯源过程示意图</span>
      </div>
      <div class="widtol mtrdiv2">
        <img src="../assets/img/11.jpg">
      </div>
      <div class="widtol mtrdiv2">
        <img src="../assets/img/12.jpg">
      </div>
    </div>
    <!---首页弹出----->
    <mt-popup
      v-model="boxShow"
      position="right">
      <div style="display: block;padding: 40px 7%;" :style="{width:w_width+'px',height:w_height+'px'}">
        <div style="text-align: right">
          <span style="font-size: 25px" @click="boxShow=false">✕</span>
        </div>
        <div class="t_list" @click="goto('/#')">首页</div>
        <div class="t_list fx_cs" @click="listShow=true">
          TMIP产品体系
          <i class="iconfont iconlujing3278 t_icon2"></i>
        </div>
        <div v-show="listShow">
          <div class="t_t_list" @click="goto('/mes')">MES 生产管理</div>
          <div class="t_t_list" @click="goto('/wms')">WMS 智慧仓储</div>
          <div class="t_t_list" @click="boxShow=false">MTR 物料溯源</div>
          <div class="t_t_list" @click="goto('/emv')">EMV 生产可视化</div>
        </div>
        <div class="t_list" @click="goto('/service')">服务与支持</div>
        <div class="t_list" style="border: 0" @click="goto('/aboutus')">关于我们</div>
      </div>
    </mt-popup>
  </div>
</template>

<script>
import util from "../components/util";
export default util.useCommon({
  data() {
    return {
      w_width:0,
      proShow:true,
      macShow:true,
      boxShow: false,
      listShow:true,
      w_height:0
    };
  },
  watch: {},
  methods: {
    change(){
      this.boxShow = true;
      console.log(this.boxShow);
    },
    goto(add) {
      this.backtop();
      this.$router.push(add);
    },
    backtop() {
      this.$emit('gotoTop');
    }
  },
  mounted() {
    console.log(window.innerWidth);
    this.w_width = window.innerWidth;
    this.w_height = window.innerHeight;
  },
  activated() {},
});
</script>
<style scoped>
.header {
  background-image: url("../assets/img/bg/3.jpg");
  height: 520px;
}
.mesdiv4 {
  background-image: url("../assets/img/bg/2.jpg");
  height: 398px;
}
.mesdiv5 {
  padding-top: 94px;
}
.mesdiv6 {
  padding-bottom: 150px;
}
.mesdiv7 {
  align-items: center;
}
.mtrdiv1{
  text-align: center;
  padding-bottom: 40px;
  background-color: #fbfbfb;
}
.mtrsp1{
  font: normal normal normal 40px/56px Microsoft YaHei;
  letter-spacing: 0px;
  color: #333333;
  opacity: 1;
  display: block;
  padding-bottom: 65px;
}
.mtrsp2{
  font: normal normal bold 24px/32px Source Han Sans CN;
  letter-spacing: 0px;
  color: #333333;
  opacity: 1;
}
.mtrdiv2{
  margin-bottom: 8px;
}
.mtrdiv2 img{
  width: 100%;
  height: auto;
}
.mtr{
  background-color: #fbfbfb;
}

</style>
